import { Icon } from "@iconify/react/dist/iconify.js";

const EmptyState = ({ icon, title, description, iconSize = 64 }) => {
  return (
    <div className="text-center py-5">
      <Icon
        icon={icon}
        width={iconSize}
        className="text-secondary-light mb-3"
      />
      <p className="text-secondary-light mb-1 fw-medium">{title}</p>
      {description && (
        <p className="text-secondary-light text-sm">{description}</p>
      )}
    </div>
  );
};

export default EmptyState;
